export default [
  {
    path: '/',
    redirect: 'managerhome',
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/home'),
    meta: {
      title: '首页',
    },
  },
  {
    path: '/search',
    name: 'search',
    component: () => import('@/views/home/search'),
    meta: {
      title: '搜索结果',
    },
  },
  {
    path: '/hot',
    name: 'hot',
    component: () => import('@/views/hot'),
    meta: {
      title: '热点专题',
    },
  },
  {
    path: '/hot/detail',
    name: 'hotDetail',
    component: () => import('@/views/hot/detail'),
    meta: {
      title: '详情',
      keepAlive: false,
    },
  },
  {
    path: '/rank/detail',
    name: 'rankDetail',
    component: () => import('@/views/rank/detail'),
    meta: {
      title: '榜单详情',
    },
  },
  {
    path: '/bookDetail',
    name: 'bookDetail',
    // component:() => import('@/views/bookDetail'),
    component: () => import('@/views/detail/bookDetail.vue'),
    meta: {
      title: '详情', //书详情
    },
  },
  {
    path: '/recommend',
    name: 'recommend',
    component: () => import('@/views/recommend'),
    meta: {
      title: '编辑评论',
    },
  },
  {
    path: '/list',
    name: 'list',
    component: () => import('@/views/list'),
    meta: {
      title: '通用列表',
    },
  },
  {
    path: '/author/detail',
    name: 'authorDetail',
    component: () => import('@/views/author/detail'),
    meta: {
      title: '作者详情',
    },
  },
  {
    path: '/prize/detail',
    name: 'prizeDetail',
    component: () => import('@/views/prize/detail'),
    meta: {
      title: '奖项详情',
    },
  },
  {
    path: '/series/detail',
    name: 'seriesDetail',
    component: () => import('@/views/series/detail'),
    meta: {
      title: '丛书详情',
    },
  },
  {
    path: '/ibhome',
    name: 'ibhome',
    component: () => import('@/views/inforandbook/home'),
    meta: {
      title: '首页',
    },
  },
  {
    path: '/ibresultlist',
    name: 'ibresultlist',
    component: () => import('@/views/inforandbook/ibresultlist'),
    meta: {
      title: '列表页',
    },
  },
  {
    path: '/firelist',
    name: 'firelist',
    component: () => import('@/views/inforandbook/firelist'),
    meta: {
      title: '书展列表页',
    },
  },
  {
    path: '/searchlist',
    name: 'searchlist',
    component: () => import('@/views/inforandbook/searchlist'),
    meta: {
      title: '检索结果页',
    },
  },
  {
    path: '/ibinfordetail',
    name: 'ibinfordetail',
    component: () => import('@/views/inforandbook/ibinfordetail'),
    meta: {
      title: '详情',
    },
  },
  {
    path: '/managerhome',
    name: 'managerhome',
    component: () => import('@/views/managerHome/home'),
    meta: {
      title: '首页',
      hidden: true,
    },
  },
  {
    path: '/BigData',
    name: 'BigData',
    component: () => import('@/views/home/BigData'),
    meta: {
      title: '本站大数据',
    },
  },
  {
    path: '/BottomInfo',
    name: 'BottomInfo',
    component: () => import('@/views/bottom/BottomInfo'),
    meta: {
      title: '关于我们',
    },
  },
  {
    path: '/searchresult',
    name: 'searchresult',
    component: () => import('@/views/managerHome/searchresult'),
    meta: {
      title: '平台检索',
    },
  },
  {
    path: '/homeStationClassify',
    name: 'homeStationClassify',
    component: () => import('@/views/managerHome/homeStationClassify'),
    meta: {
      title: '本站分类法',
    },
  },
  {
    path: '/publisher',
    name: 'publisher',
    component: () => import('@/views/publisher'),
    meta: {
      title: '出版社',
    },
  },
  {
    path: '/publisherdetail',
    name: 'publisherdetail',
    component: () => import('@/views/publisher/detail'),
    meta: {
      title: '出版社详情',
    },
  },
  {
    path: '/librarydetail',
    name: 'librarydetail',
    component: () => import('@/views/publisher/librarydetail'),
    meta: {
      title: '图书馆详情',
    },
  },
  {
    path: '/noticdetail',
    name: 'noticdetail',
    component: () => import('@/views/managerHome/noticdetail'),
    meta: {
      title: '公告详情',
    },
  },
  {
    path: '/nopage',
    name: 'nopage',
    component: () => import('@/views/managerHome/nopage'),
    meta: {
      title: '默认访问',
    },
  },
  {
    path: '/pay',
    name: 'pay',
    component: () => import('@/views/pay/index'),
    meta: {
      title: '支付服务',
    },
  },
]



// WEBPACK FOOTER //
// ./src/router/routes.js